import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useHistory, useLocation } from "react-router";
import AddContractDetailsModal from "../Components/AddContractDetailsModal.js";
import { Post } from "../Axios/AxiosFunctions";
import { URL as BaseURL, apiHeader } from "../Config/apiUrl";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddContractTypeModal from "../Components/AddContractTypeModal";
import { FaUpload } from "react-icons/fa";

const Contract = ({ setfooterStyle }) => {
  const history = useHistory();
  const [isAdding, setIsAdding] = useState(false);
  const [isOwnData, setIsOwnData] = useState(false);
  // const { jobId, craftmanId } = useLocation()?.state;
  const _data = useLocation()?.state;
  const jobId = _data?.jobId;
  const craftmanId = _data?.craftmanId;
  const _title = _data?.title;
  const _companyName = _data?.companyName;

  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const [isLoading, setIsLoading] = useState(false);
  const [date, setDate] = useState("___");
  const [month, setMonth] = useState("____");
  const [year, setYear] = useState("____");
  const [meetingDate, setMeetingDate] = useState("");
  const [meetingTime, setMeetingTime] = useState("");
  const [meetingAddress, setMeetingAddress] = useState("");
  const [extraComment, setExtraComment] = useState("");
  const [companyName, setCompanyName] = useState(
    _companyName || "[company name]"
  );
  const [employeeName, setEmployeeName] = useState("[employee name]");
  const [city, setCity] = useState("city");
  const [cityState, setCityState] = useState("state");
  const [cityDistrict, setCityDistrict] = useState("district");
  const [jobTitle, setJobTitle] = useState(_title || "[job title]");
  const [wage, setWage] = useState("____");
  const [wageRate, setWageRate] = useState("[per hour/per annum]");
  const [performanceReviewBasis, setPerformanceReviewBasis] =
    useState("[quarterly/annual]");
  const [benefits, setBenefits] = useState("[list benefits, if any]");
  const [probationtimeFrame, setProbationTimeFrame] = useState("[time frame]");
  const [timeForVacation, setTimeForVacation] = useState(
    "[length of time for vacation]"
  );
  const [timeForSickOrPersonal, setTimeForSickOrPersonal] = useState(
    "[length of time for sick/personal days]"
  );
  const [terminationTimeLength, setTerminationTimeLength] =
    useState("[length of time]");
  const [solicitBusinessTimeFrame, setSolicitBusinessTimeFrame] =
    useState("[time frame]");
  const [countryName, setCountryName] = useState("[country name]");
  const [province, setProvince] = useState("province");
  const [territory, setTerritory] = useState("territory]");
  const [allFieldsCompleted, setAllFieldsCompleted] = useState(false);

  const [motivationalLetter, setMotivationalLetter] = useState(null);
  const [motivationalLetterFile, setMotivationalLetterFile] = useState(null);

  const [contractType, setContractType] = useState("template");

  const [ownText, setOwnText] = useState("");

  const [contractText, setContractText] = useState(
    `This contract, dated on the ${date} day of ${month} in the year ${year}, is made between ${companyName} and ${employeeName} of ${city}, ${cityState}. This document constitutes an employment agreement between these two parties and is governed by the laws of ${cityState}.\n\nWHEREAS the Employer desires to retain the services of the Employee, and the Employee desires to render such services, these terms and conditions are set forth.\n\nIN CONSIDERATION of this mutual understanding, the parties agree to the following terms and conditions: \n\n Employment \nThe Employee agrees that he or she will faithfully and to the best of their ability to carry out the duties and responsibilities communicated to them by the Employer. The Employee shall comply with all company policies, rules and procedures at all times. \n\nPosition \nAs a ${jobTitle}, it is the duty of the Employee to perform all essential job functions and duties. From time to time, the Employer may also add other duties within the reasonable scope of the Employee’s work. \n\nCompensation \nAs compensation for the services provided, the Employee shall be paid a wage of $${wage} ${wageRate} and will be subject to a / an ${performanceReviewBasis} performance review. All payments shall be subject to mandatory employment deductions (State & Federal Taxes, Social Security, Medicare).\n\n Benefits\n The Employee has the right to participate in any benefits plans offered by the Employer. The employer currently offers ${benefits}. Access to these benefits will only be possible after the probationary period has passed. \n\nProbationary Period \nIt is understood that the first ${probationtimeFrame} of employment constitutes a probationary period. During this time, the Employee is not eligible for paid time off or other benefits. During this time, the Employer also exercises the right to terminate employment at any time without advanced notice. \n\nPaid Time Off \nFollowing the probationary period, the Employee shall be eligible for the following paid time off: • ${timeForVacation} for Vacation Leave • ${timeForSickOrPersonal} for Sick/Personal Leave • Bereavement leave may be granted if necessary. \n\nThe employer reserves the right to modify any paid time off policies. \n\nTermination \nIt is the intention of both parties to form a long and mutually profitable relationship. However, this relationship may be terminated by either party at any time provided ${terminationTimeLength} written notice is delivered to the other party. \nThe Employee agrees to return any Employer property upon termination. \n\nNon-Competition and Confidentiality \nAs an Employee, you will have access to confidential information that is the property of the Employer. You are not permitted to disclose this information outside of the Company. \n\nDuring your time of Employment with the Employer, you may not engage in any work for another Employer that is related to or in competition with the Company. You will fully disclose to your Employer any other Employment relationships that you have and you will be permitted to seek other employment provided that (a.) it does not detract from your ability to fulfill your duties, and (b.) you are not assisting another organization in competing with the employer. \n\nIt is further acknowledged that upon termination of your employment, you will not solicit business from any of the Employer’s clients for a period of at least ${solicitBusinessTimeFrame}. \n\nEntirety\n This contract represents the entire agreement between the two parties and supersedes any previous written or oral agreement. This agreement may be modified at any time, provided the written consent of both the Employer and the Employee. \n\nLegal Authorization\n The Employee agree that he or she is fully authorized to work in ${countryName} and can provide proof of this with legal documentation. This documentation will be obtained by the Employer for legal records. \n\nSeverability \nThe parties agree that if any portion of this contract is found to be void or unenforceable, it shall be struck from the record and the remaining provisions will retain their full force and effect. \n\nJurisdiction \nThis contract shall be governed, interpreted, and construed in accordance with the laws of [${cityState}, ${province} or ${territory}]. \n\nIn witness and agreement whereof, the Employer has executed this contract with due process through the authorization of official company agents and with the consent of the Employee, given here in writing Meeting Time ${meetingTime} Meeting Date ${meetingDate} Meeting Address ${meetingAddress} \n\nExtra Comments ${extraComment}.`
  );
  const accessToken = useSelector((state) => state.authReducer.access_token);

  // send Contract
  async function sendContract() {
    if (!allFieldsCompleted) {
      toast.error("Please fill out all the fields", { position: "top-center" });
      return;
    }
    setIsLoading(true);
    const url = "job/hireCraftman";
    let params = {
      jobTitle: jobTitle,
      companyName: companyName,
      craftmansUserId: craftmanId,
      jobId: jobId,
      // text: contractText,
      ...(contractType === "template" && { text: contractText }),
      ...(contractType === "ownData" && { text: ownText }),
    };

    const formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    if (motivationalLetterFile) {
      formData.append("additionalDoc", motivationalLetterFile);
    }

    const response = await Post(BaseURL(url), formData, apiHeader(accessToken));
    if (response !== undefined) {
      setIsLoading(false);
      console.log("response", response);
      toast.success("Job contract send successfully", {
        position: "top-right",
      });
      history.push("/dashboard");
    }
    setIsLoading(false);
  }

  useEffect(() => {
    setContractText(
      `This contract, dated on the ${date} day of ${month} in the year ${year}, is made between ${companyName} and ${employeeName} of ${city}, ${cityState}. This document constitutes an employment agreement between these two parties and is governed by the laws of ${cityState}.\n\nWHEREAS the Employer desires to retain the services of the Employee, and the Employee desires to render such services, these terms and conditions are set forth.\n\nIN CONSIDERATION of this mutual understanding, the parties agree to the following terms and conditions: \n\nEmployment \nThe Employee agrees that he or she will faithfully and to the best of their ability to carry out the duties and responsibilities communicated to them by the Employer. The Employee shall comply with all company policies, rules and procedures at all times. \n\nPosition \nAs a ${jobTitle}, it is the duty of the Employee to perform all essential job functions and duties. From time to time, the Employer may also add other duties within the reasonable scope of the Employee’s work. \n\nCompensation \nAs compensation for the services provided, the Employee shall be paid a wage of $${wage} ${wageRate} and will be subject to a(n) ${performanceReviewBasis} performance review. All payments shall be subject to mandatory employment deductions (State & Federal Taxes, Social Security, Medicare).\n\n Benefits\n The Employee has the right to participate in any benefits plans offered by the Employer. The employer currently offers ${benefits}. Access to these benefits will only be possible after the probationary period has passed. \n\nProbationary Period \nIt is understood that the first ${probationtimeFrame} of employment constitutes a probationary period. During this time, the Employee is not eligible for paid time off or other benefits. During this time, the Employer also exercises the right to terminate employment at any time without advanced notice. \n\nPaid Time Off \nFollowing the probationary period, the Employee shall be eligible for the following paid time off: • ${timeForVacation} for Vacation Leave • ${timeForSickOrPersonal} for Sick/Personal Leave • Bereavement leave may be granted if necessary. \n\nThe employer reserves the right to modify any paid time off policies. \n\nTermination \nIt is the intention of both parties to form a long and mutually profitable relationship. However, this relationship may be terminated by either party at any time provided ${terminationTimeLength} written notice is delivered to the other party. \nThe Employee agrees to return any Employer property upon termination. \n\nNon-Competition and Confidentiality \nAs an Employee, you will have access to confidential information that is the property of the Employer. You are not permitted to disclose this information outside of the Company. \n\nDuring your time of Employment with the Employer, you may not engage in any work for another Employer that is related to or in competition with the Company. You will fully disclose to your Employer any other Employment relationships that you have and you will be permitted to seek other employment provided that (a.) it does not detract from your ability to fulfill your duties, and (b.) you are not assisting another organization in competing with the employer. \n\nIt is further acknowledged that upon termination of your employment, you will not solicit business from any of the Employer’s clients for a period of at least ${solicitBusinessTimeFrame}. \n\nEntirety\n This contract represents the entire agreement between the two parties and supersedes any previous written or oral agreement. This agreement may be modified at any time, provided the written consent of both the Employer and the Employee. \n\nLegal Authorization\n The Employee agree that he or she is fully authorized to work in ${countryName} and can provide proof of this with legal documentation. This documentation will be obtained by the Employer for legal records. \n\nSeverability \nThe parties agree that if any portion of this contract is found to be void or unenforceable, it shall be struck from the record and the remaining provisions will retain their full force and effect. \n\nJurisdiction \nThis contract shall be governed, interpreted, and construed in accordance with the laws of [${cityState}, ${province} or ${territory}]. \n\nIn witness and agreement whereof, the Employer has executed this contract with due process through the authorization of official company agents and with the consent of the Employee, given here in writing Meeting Time ${meetingTime} Meeting Date ${meetingDate} Meeting Address ${meetingAddress} \n\n Extra Comments ${extraComment}.`
    );
  }, [
    date,
    month,
    year,
    companyName,
    employeeName,
    city,
    cityState,
    cityDistrict,
    jobTitle,
    wage,
    wageRate,
    performanceReviewBasis,
    benefits,
    probationtimeFrame,
    timeForVacation,
    timeForSickOrPersonal,
    terminationTimeLength,
    solicitBusinessTimeFrame,
    countryName,
    province,
    territory,
    contractText,
    meetingDate,
    meetingTime,
    meetingAddress,
    extraComment,
  ]);

  // to scroll top up when page refreshed
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  // uploadImages
  const uploadImages = (
    event,
    setterFile,
    setterDisplay,
    c = false,
    imageValidation = false,
    pdfValidation = false
  ) => {
    if (event.target.files.length > 0) {
      // pdfValidation
      if (pdfValidation) {
        if (event.target.files?.length > 0) {
          if (!["application/pdf"].includes(event.target.files[0].type)) {
            return toast.error(
              "Please upload a valid CV [only pdf is allowed]"
            );
          }
        }
      }

      setterFile(event.target.files[0]);
      let reader = new FileReader();
      reader.onload = (event) => {
        setterDisplay(event.target.result);
      };

      reader.readAsDataURL(event.target.files[0]);
    }
  };

  return (
    <>
      <section className="contract">
        <div className="container small_container">
          <div className="row" style={{ margin: 0 }}>
            <div className="col-md-12">
              <div className="route">
                Home / Contracts /<b> Contract Name</b>
              </div>
              <div className="col-md-12">
                <div className="text-end btn_sec">
                  <Button onClick={() => setIsAdding(true)} className="me-2">
                    Add
                  </Button>
                  <Button onClick={() => setIsOwnData(true)}>
                    Contract Type
                  </Button>
                </div>
              </div>
              <div className="white-box">
                <h1>Employment Contract</h1>
                {contractType === "template" ? (
                  <>
                    {contractText}
                    <div className="signature mt-5">
                      <div>
                        <p className="signature-line">
                          _________________________________________________
                        </p>
                        <p>
                          <b className="black">Company Official Signature</b>
                        </p>
                        <p>
                          <b className="black">Date: {date}</b>
                        </p>
                      </div>
                      <div>
                        <p className="signature-line">
                          _________________________________________________
                        </p>
                        <p>
                          <b className="black">Employee Signature</b>
                        </p>
                        <p>
                          <b className="black">Date</b>
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <textarea
                    className="w-100 p-3"
                    rows={20}
                    placeholder="Enter your text"
                    value={ownText}
                    onChange={(e) => setOwnText(e.target.value)}
                  />
                )}

                <div className="send-contract-btn">
                  {/* attach additional Letter */}
                  <div className="doc-container-x2">
                    <label>
                      <p
                        style={{
                          color: "white",
                          marginBottom: "0px",
                          marginRight: "5px",
                        }}
                      >
                        {`${
                          motivationalLetterFile
                            ? `${motivationalLetterFile?.name.substr(0, 20)}${
                                motivationalLetterFile?.name.length > 20
                                  ? "...pdf"
                                  : ""
                              }`
                            : "Add Additional Document"
                        }`}
                      </p>
                      <FaUpload className="doc-container-xixon" />
                      <input
                        type="file"
                        accept="application/pdf"
                        size="5"
                        class="file_upload_form3rd"
                        onChange={(e) =>
                          uploadImages(
                            e,
                            setMotivationalLetterFile,
                            setMotivationalLetter,
                            true,
                            false,
                            true
                          )
                        }
                      />
                    </label>
                  </div>
                  <button onClick={() => sendContract()} disabled={isLoading}>
                    {isLoading ? "Sending Contract..." : "Send Contract"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddContractDetailsModal
          open={isAdding}
          setOpen={setIsAdding}
          date={date}
          setDate={setDate}
          month={month}
          setMonth={setMonth}
          year={year}
          setYear={setYear}
          companyName={companyName}
          setCompanyName={setCompanyName}
          employeeName={employeeName}
          setEmployeeName={setEmployeeName}
          city={city}
          setCity={setCity}
          cityState={cityState}
          setCityState={setCityState}
          cityDistrict={cityDistrict}
          setCityDistrict={setCityDistrict}
          jobTitle={jobTitle}
          setJobTitle={setJobTitle}
          wage={wage}
          setWage={setWage}
          wageRate={wageRate}
          setWageRate={setWageRate}
          performanceReviewBasis={performanceReviewBasis}
          setPerformanceReviewBasis={setPerformanceReviewBasis}
          benefits={benefits}
          setBenefits={setBenefits}
          probationtimeFrame={probationtimeFrame}
          setProbationTimeFrame={setProbationTimeFrame}
          timeForVacation={timeForVacation}
          setTimeForVacation={setTimeForVacation}
          timeForSickOrPersonal={timeForSickOrPersonal}
          setTimeForSickOrPersonal={setTimeForSickOrPersonal}
          terminationTimeLength={terminationTimeLength}
          setTerminationTimeLength={setTerminationTimeLength}
          solicitBusinessTimeFrame={solicitBusinessTimeFrame}
          setSolicitBusinessTimeFrame={setSolicitBusinessTimeFrame}
          countryName={countryName}
          setCountryName={setCompanyName}
          province={province}
          setProvince={setProvince}
          territory={territory}
          setTerritory={setTerritory}
          setAllFieldsCompleted={setAllFieldsCompleted}
          meetingDate={meetingDate}
          setMeetingDate={setMeetingDate}
          meetingTime={meetingTime}
          setMeetingTime={setMeetingTime}
          meetingAddress={meetingAddress}
          setMeetingAddress={setMeetingAddress}
          extraComment={extraComment}
          setExtraComment={setExtraComment}
        />
        <AddContractTypeModal
          open={isOwnData}
          setOpen={setIsOwnData}
          contractType={contractType}
          setContractType={setContractType}
          setAllFieldsCompleted={setAllFieldsCompleted}
          // modalstate={modalstate}
        />
      </section>
    </>
  );
};

export default Contract;
